

const productsInitialState = {
    homepagemetadataList: [],
    aboutuspagemetadataList: [],
    servicespagemetadataList: [],
    careerpagemetadataList: [],
    portfoliometadataList: [],
    contactuspagemetadataList:[],
    outsourcingsoftwaredevelopmentmetadataList: [],
    mobileappdevelopmentmetadataList: [],
    webdevelopmentmetadataList: [],
    cmsmetadataList: [],
    erpmetadataList: [],
    iotmetadataList: [],
    mlmetadataList: [],
    digitalmarketingmetadataList: [],
    ivrmetadataList: [],
    dotnetmetadataList: [],

    // user: {}
}


const HomeReducer = (state = productsInitialState, action) => {

    switch (action.type) {
        case "SET_HOME_PAGE_METADATA":
            return {
                ...state,
                homepagemetadataList: action.payload
            };

        case "SET_ABOUTUS_PAGE_METADATA":
            return {
                ...state,
                aboutuspagemetadataList: action.payload
            };

        case "SET_SERVICES_PAGE_METADATA":
            return {
                ...state,
                servicespagemetadataList: action.payload
            };

        case "SET_CAREER_PAGE_METADATA":
            return {
                ...state,
                careerpagemetadataList: action.payload
            };

        case "SET_PORTFOLIO_METADATA":
            return {
                ...state,
                portfoliometadataList: action.payload
            };

        case "SET_CONTACTUS_PAGE_METADATA":
            return {
                ...state,
                contactuspagemetadataList: action.payload
            };
        case "SET_OUTSOURCING_SOFTWARE_DEVELOPMENT_METADATA":
            return {
                ...state,
                outsourcingsoftwaredevelopmentmetadataList: action.payload
            };
        case "SET_MOBILE_APP_DEVELOPMENT_METADATA":
            return {
                ...state,
                mobileappdevelopmentmetadataList: action.payload
            };
        case "SET_WEB_DEVELOPMENT_METADATA":
            return {
                ...state,
                webdevelopmentmetadataList: action.payload
            };
        case "SET_CMS_METADATA":
            return {
                ...state,
                cmsmetadataList: action.payload
            };
        case "SET_ERP_METADATA":
            return {
                ...state,
                erpmetadataList: action.payload
            };
        case "SET_IOT_METADATA":
            return {
                ...state,
                iotmetadataList: action.payload
            };
        case "SET_ML_METADATA":
            return {
                ...state,
                mlmetadataList: action.payload
            };
        case "SET_DIGITAL_MARKETING_METADATA":
            return {
                ...state,
                digitalmarketingmetadataList: action.payload
            };
        case "SET_IVR_METADATA":
            return {
                ...state,
                ivrmetadataList: action.payload
            };
        case "SET_DOT_NET_METADATA":
            return {
                ...state,
                dotnetmetadataList: action.payload
            };

        default:
            return state
    }
}

export default HomeReducer;